const verifyHierarchy = (props, hierarchy) => {
  if (props.hierarchyType === hierarchy) {
    return props.hierarchy;
  } else {
    return " - ";
  }
};

export default verifyHierarchy;
